import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectButtonComponent } from './select-button.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [SelectButtonComponent],
    exports: [SelectButtonComponent],
})
export class UiSelectButtonModule {}

